import CountUp from 'react-countup';
export default function CounterUpThree(){
    return(
        <>
        <section className="counter-area">
			<div className="container">
				<div className="counter-bg2 white-bg pt-110 pb-85 pt-md-60 pb-md-30 pt-xs-60 pb-xs-30">
					<div className="row align-items-center">
						<div className="col-lg-4 col-md-4">
							<div className="count-text2 text-center mb-30">
								<h3><span className="counter"><CountUp end={3000} /></span></h3>
								<p>Successful projects</p>
								<h5 className="text-heding3">On the other hand we denounce</h5>
							</div>
						</div>
						<div className="col-lg-4 col-md-4">
							<div className="count-text2 count-line text-center mb-30">
								<h3><span className="counter"><CountUp end={470} /></span></h3>
								<p>Active Clients</p>
								<h5 className="text-heding3">On the other hand we denounce</h5>
							</div>
						</div>
						<div className="col-lg-4 col-md-4">
							<div className="count-text2 text-center mb-30">
								<h3><span className="counter"><CountUp end={100} /></span>+</h3>
								<p>Worldwide Base</p>
								<h5 className="text-heding3">On the other hand we denounce</h5>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
        </>
    )
}